import { useQuery } from "@tanstack/react-query";
import { workOrderKeys } from "../work-order.keys";
import { workOrderApi } from "../service";

export function useWorkOrderDetail(workOrderId?: string) {
  return useQuery({
    queryKey: workOrderKeys.detail(workOrderId ?? ""),
    queryFn: () => workOrderApi.getById(workOrderId as string).then((response) => response.data),
    enabled: Boolean(workOrderId),
    retry: false
  });
}
